import React, { useState } from 'react';

const FONT = '"Nunito","Baloo 2",sans-serif';

function normalize(s) {
  return (s || '').trim().toLowerCase().replace(/\s+/g, ' ');
}

export default function FillBlankGame({ payload, onAnswer, disabled }) {
  const [value, setValue] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const submit = () => {
    if (submitted) return;
    const accepted = (payload.accepted_answers || []).map(normalize);
    const ok = accepted.includes(normalize(value));
    setSubmitted(true);
    if (onAnswer) onAnswer({ is_correct: ok, user_answer: value });
  };

  const sentence = payload.sentence_with_blank || '';
  const parts = sentence.split('___');

  return (
    <div style={{ maxWidth: 560, margin: '0 auto', fontFamily: FONT }}>
      <div
        style={{
          padding: 22,
          background: '#fefce8',
          border: '2px solid #fde68a',
          borderRadius: 14,
          textAlign: 'center',
          fontSize: 22,
          fontWeight: 600,
          lineHeight: 1.5,
        }}
      >
        {parts[0]}
        <span
          style={{
            display: 'inline-block',
            minWidth: 80,
            padding: '2px 10px',
            margin: '0 4px',
            borderBottom: '3px solid #1e40af',
            color: '#1e40af',
            fontWeight: 800,
          }}
        >
          {submitted ? value || '____' : '____'}
        </span>
        {parts.slice(1).join('___')}
      </div>

      {payload.hint_vi ? (
        <div style={{ marginTop: 8, color: '#6b7280', fontStyle: 'italic', textAlign: 'center' }}>
          💡 {payload.hint_vi}
        </div>
      ) : null}

      <div style={{ marginTop: 18, display: 'flex', gap: 10 }}>
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && submit()}
          disabled={submitted || disabled}
          placeholder="Gõ từ điền vào..."
          autoFocus
          style={{
            flex: 1,
            padding: '12px 14px',
            border: '2px solid #d1d5db',
            borderRadius: 10,
            fontSize: 18,
            fontFamily: FONT,
          }}
        />
        <button
          onClick={submit}
          disabled={submitted || disabled || !value.trim()}
          style={{
            padding: '0 22px',
            background: '#1e40af',
            color: '#fff',
            border: 'none',
            borderRadius: 10,
            fontSize: 16,
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          Trả lời
        </button>
      </div>

      {submitted ? (
        <div style={{ marginTop: 14, padding: 12, background: '#f3f4f6', borderRadius: 10 }}>
          <div style={{ fontWeight: 700 }}>
            Đáp án: <code>{(payload.accepted_answers || []).join(' / ')}</code>
          </div>
          {payload.explanation_vi ? (
            <div style={{ marginTop: 6, color: '#374151' }}>{payload.explanation_vi}</div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
